import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
const placeholderShimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`
const ShimmerWrapper = styled.div`
  width: ${props => (props.width ? props.width : '120px')};
  height: ${props => (props.height ? props.height : '40px')};
  background: #f6f7f8;
  border-radius: 8px;
  background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
  background-repeat: no-repeat;
  background-size: 800px ${props => props.height && props.height};
  display: inline-block;
  position: relative;
  -webkit-animation-duration: 0.8s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: ${placeholderShimmer};
  -webkit-animation-timing-function: linear;
`

class Shimmer extends Component {
  render() {
    const { width, height, ...props } = this.props
    return <ShimmerWrapper width={width} height={height} {...props} />
  }
}

export default Shimmer



// WEBPACK FOOTER //
// ./src/components/Shimmer.js